/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import MobileJoinForFreeButton from 'bundles/composable-page-header-consumer/components/MobileJoinForFreeButton';
import MainNavigationWrapper from 'bundles/composable-page-header/components/MainNavigationWrapper';
import NavAiSparkleGridItem from 'bundles/composable-page-header/components/grid-items/NavAiSparkleGridItem';
import CourseraHomeLogo from 'bundles/composable-page-header/components/grid-items/home-logo/CourseraHomeLogo';
import HomeLogoGridItemModule from 'bundles/composable-page-header/components/grid-items/home-logo/HomeLogoGridItemModule';
import MobileMenuIconGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuIconGridItem';
import MobileSearchBarGridItem from 'bundles/composable-page-header/components/grid-items/mobile/MobileSearchBarGridItem';
import DefaultLoggedOutMobileMenuConfig from 'bundles/composable-page-header/module-renderers/DefaultLoggedOutMobileMenuConfig';

type Props = {
  hideAuthButtons?: boolean;
  showDiscoveryElements?: boolean;
  showSearch?: boolean;
  additionalRightItems?: React.ReactNode;
};

const styles = {
  gridItemContainer: css`
    display: flex;
    align-items: center;
  `,
};

const LoggedOutConsumerMobileMainNav = ({
  showDiscoveryElements = true,
  showSearch = true,
  hideAuthButtons,
  additionalRightItems,
}: Props) => {
  return (
    <MainNavigationWrapper>
      <Grid container justifyContent="space-between" alignItems="center" wrap="nowrap">
        <Grid item css={styles.gridItemContainer}>
          <MobileMenuIconGridItem
            menuConfig={<DefaultLoggedOutMobileMenuConfig hideAuthButtons={hideAuthButtons} />}
            homeLogo={<HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo />]} className="c-logo" />}
          />
          <HomeLogoGridItemModule href="/" logos={[<CourseraHomeLogo />]} className="c-logo" />
        </Grid>
        <Grid item css={styles.gridItemContainer}>
          <NavAiSparkleGridItem />
          {showSearch && showDiscoveryElements && <MobileSearchBarGridItem />}
          {!hideAuthButtons && <MobileJoinForFreeButton />}
          {additionalRightItems}
        </Grid>
      </Grid>
    </MainNavigationWrapper>
  );
};

export default LoggedOutConsumerMobileMainNav;
